
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured-products",
      function () {
        return require("private-next-pages/featured-products/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/featured-products"])
      });
    }
  